import React from "react";
import { Divider, Grid2, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const StatusSection = ({ label, value, text }) => {
  return (
    <>
      <Grid2 container spacing={1} sx={{ pt: 2, pl: 4, pr: 4 }}>
        <Grid2 size={6}>
          <Typography variant="body2" color="textSecondary">
            {label}
          </Typography>
        </Grid2>
        <Grid2 size={6}>
          <Typography
            variant="body2"
            sx={{
              mb: 2,
              color: "#494949ff",
              display: "flex",
              alignSelf: "center",
            }}
          >
            {value ? (
              <>
                <CheckCircleOutlineIcon fontSize="small" color="success" />
                &nbsp; {text}
              </>
            ) : (
              <>
                <ErrorOutlineIcon fontSize="small" color="action" />
                &nbsp; Suspended
              </>
            )}
          </Typography>
        </Grid2>
      </Grid2>
      <Divider />
    </>
  );
};
